import Vue from 'vue';
import i18n from '../plugins/i18n';
import VueRouter from 'vue-router';
import middlewarePipeline from './middleware/index';
import Authentication from './middleware/authentication';
import Authorization from './middleware/authorization';

import qs from 'qs';

import SignIn from '../views/SignIn';
import Panel from '../views/Panel';
import Dashboard from '../views/Dashboard';
import FaxesList from '../views/FaxesList';
import UsersList from '../views/UsersList';
import LogsList from '../views/LogsList';
import FaxChannels from '../views/FaxChannels';
import FaxNumbers from '../views/FaxNumbers';
import Connectors from '../views/Connectors';
import Resellers from '../views/Resellers';
import Inbox from '../views/Inbox';
import SubscriptionClassesList from '../views/SubscriptionClassesList';
import SubscriptionList from '../views/SubscriptionList';
import Tickets from '../views/Tickets';
import Receipts from '../views/Receipts';
import SettlementRequests from '../views/SettlementRequests';
import SettlementRequestDetails from '../views/SettlementRequestDetails';
import TicketDetails from '../views/TicketDetails';
import BlacklistNumbers from '../views/BlacklistNumbers';
import Commissions from '../views/Commissions';


import Forbidden from '../views/errors/403';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Panel,
        children : [
            {
                path: '/',
                name: 'Dashboard',
                component: Dashboard,
                meta : {
                    title : "پیشخوان",
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/faxes/inbox',
                name : 'Inbox',
                component: Inbox,
                meta : {
                    title : "فکس های دریافتی",
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/faxes/inbox',
                name : 'Inbox',
                component: Inbox,
                meta : {
                    title : "فکس های دریافتی",
                    middleware : [Authentication]
                }
            },
            {
                path: '/faxes/sent',
                name : 'FaxesList',
                component: FaxesList,
                meta : {
                    title : "فکس های ارسالی",
                    middleware : [Authentication,Authorization]
                }
            },

            {
                path: '/subscription-classes',
                name : 'SubscriptionClassesList',
                component: SubscriptionClassesList,
                meta : {
                    title : "بسته های اشتراکی",
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/subscriptions',
                name : 'SubscriptionList',
                component: SubscriptionList,
                meta : {
                    title : "اشتراک های فعال",
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/fax-channels',
                name : 'FaxChannels',
                component: FaxChannels,
                meta : {
                    title : "کانال های مدیریت فکس",
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/fax-numbers',
                name : 'FaxNumbers',
                component: FaxNumbers,
                meta : {
                    title : "مدیریت شماره های فکس",
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/fax-channels',
                name : 'FaxChannels',
                component: FaxChannels,
                meta : {
                    title : "کانال های مدیریت فکس",
                    middleware : [Authentication]
                }
            },
            {
                path: '/fax-numbers',
                name : 'FaxNumbers',
                component: FaxNumbers,
                meta : {
                    title : "مدیریت شماره های فکس",
                    middleware : [Authentication]
                }
            },

            {
                path: '/users',
                name : 'UsersList',
                component: UsersList,
                meta : {
                    title : "لیست کاربران",
                    // permissions : ['users'],
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/connectors',
                name : 'Connectors',
                component: Connectors,
                meta : {
                    title : "لیست معرف ها",
                    permissions : ['connectors'],
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/resellers',
                name : 'Resellers',
                component: Resellers,
                meta : {
                    title : "لیست نمایندگان",
                    permissions : ['resellers'],
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/receipts',
                name : 'Receipts',
                component: Receipts,
                meta : {
                    title : "لیست پرداخت ها",
                    permissions : ['receipts'],
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/commissions',
                name : 'Commissions',
                component: Commissions,
                meta : {
                    title : "کمیسیون ها",
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/tickets',
                name : 'Tickets',
                component: Tickets,
                meta : {
                    title : "پشتیبانی",
                    middleware : [Authentication]
                }
            },
            {
                path: '/tickets/:ticketNumber',
                name : 'TicketDetails',
                component: TicketDetails,
                meta : {
                    title : "پشتیبانی",
                    middleware : [Authentication]
                }
            },
            {
                path: '/blacklist-numbers',
                name : 'BlacklistNumbers',
                component: BlacklistNumbers,
                meta : {
                    title : "بلک لیست",
                    // permissions : ['resellers'],
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/settlement-requests',
                name : 'SettlementRequests',
                component: SettlementRequests,
                meta : {
                    title : "تسویه حساب ها",
                    // permissions : ['resellers'],
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/settlement-requests/:id',
                name : 'SettlementRequestDetails',
                component: SettlementRequestDetails,
                meta : {
                    title : "جزییات تسویه حساب",
                    // permissions : ['resellers'],
                    middleware : [Authentication,Authorization]
                }
            },
            {
                path: '/logs',
                name : 'Logs',
                component: LogsList,
                meta : {
                    title : "لاگ ها",
                    middleware : [Authentication,Authorization]
                }
            }


        ]
    },
    {
        path: '/signin',
        name: 'SignIn',
        component: SignIn,
        meta : {
            title : "ورود"
        }
    },
    {
        path: '/forbidden',
        name: 'Forbidden',
        component: Forbidden,
        meta : {
            title : "دسترسی غیره مجاز"
        }
    }

]

const router = new VueRouter({
    mode : "history",
    linkActiveClass : "active",
    routes,
    parseQuery(query) {
        return qs.parse(query);
    },
    stringifyQuery(query) {
        var result = qs.stringify(query);

        return result ? ('?' + result) : '';
    }
})

router.beforeEach((to, from, next) => {
    window.document.title = [to.meta.title, i18n.t('application_title')].join(' - ');

    if (!to.meta.middleware) {
        return next()
    }

    const middleware = to.meta.middleware

    const context = {
        to,
        from,
        next,
        router
    }
    return middleware[0]({
        ...context,
        next: middlewarePipeline(context, middleware, 1)
    })
})

export default router
